import MuiInput from '../MaterialComponent/MuiInput'
import MuiButton from '../MaterialComponent/MuiButton'
import Link from '@mui/material/Link'
import Grid from '@mui/material/Grid'
import './sendIdWithEmailForm.css'

const SendIdWithEmailForm = (props) => {
    return (
        <>
            <form className="form" onSubmit={props.onSubmit}>
                <h5>Forgot ID</h5>
                <p style={{ fontWeight: 'bold', fontSize: 13 }}>
                    Please enter your registered Email ID to receive your TMDSAS
                    ID or JAMP ID
                </p>
                <MuiInput
                    required
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    onChange={props.onChange}
                    autoFocus
                    error={props.error}
                    value={props.value}
                    helperText={props.helperText}
                />
                <MuiButton>Submit</MuiButton>
                <Grid container justifyContent="flex-end">
                    <Link
                        onClick={props.onClickCancel}
                        href=""
                        color="#0A5C89"
                        underline="hover"
                        style={{ fontSize: 17, fontWeight: '500' }}>
                        Cancel
                    </Link>
                </Grid>
            </form>
        </>
    )
}
export default SendIdWithEmailForm
